import {
  trackEvent,
  EVENT_CATEGORY,
  EVENT_TYPE,
} from "@lululemon/mwa-analytics";

export const formatStoryData = ({ stories, watchAgainText }) => {
  if (!stories?.length) return stories;

  const formattedStories = stories.map((s, i) => {
    const isVideoContent =
      s?.fields?.media?.sys?.contentType?.sys?.id === "video";
    const url = isVideoContent
      ? s?.fields?.media?.fields?.videoUrl
      : s?.fields?.media?.fields?.imageUrl;
    return {
      ...s,
      url: url,
      tracks: [
        {
          src: isVideoContent ? s?.fields?.media?.fields?.videoCaptionsUrl : "",
        },
      ],
      type: isVideoContent ? "videoReel" : "image",
      duration: isVideoContent ? s?.fields?.videoDuration * 1000 : null,
      cta: {
        text: s?.fields?.cta?.fields?.name,
        url: s?.fields?.cta?.fields?.webRoute,
      },
      i,
    };
  });
  const lastStory = formattedStories.pop();

  return [...formattedStories, { ...lastStory, watchAgainText }];
};

export const getReelsSizeConfig = (deviceType) => {
  if (typeof window !== "undefined") {
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;
    const isMobileLandscape = isLandscape && window.screen.height < 768;

    if (deviceType.isMobile || isMobileLandscape) {
      return {
        isMobile: true,
        height: isLandscape ? "100vw" : window.innerHeight,
        width: isLandscape ? "100vh" : "100vw",
      };
    }
  }

  return {
    isDesktop: true,
    height: "calc(100vh - 80px)",
    width: "calc((100vh - 80px) * 0.5625)",
  };
};

/**
 * Returns a function that sets the width of the progress bar element based on the video progress
 * @param {HTMLVideoElement} videoElement
 * @param {HTMLDivElement} progressElement
 * @param {React.Ref} animationRef
 * @returns {function|undefined}
 */
export const getAnimateProgressBar = (
  videoElement,
  progressElement,
  animationRef
) => {
  if (!videoElement || !progressElement || !animationRef) {
    return;
  }

  const animationCallback = () => {
    // Percentage of video played
    const width = (videoElement.currentTime * 100) / videoElement.duration;
    if (!isNaN(width)) {
      progressElement.style.width = `${width}%`;
    }

    animationRef.current = requestAnimationFrame(animationCallback);
  };

  return animationCallback;
};

/**
 * Sets the height of a content element to the sum of the heights of its child nodes,
 * plus an optional offset
 * @param {HTMLElement} content - The content element to set the height
 * @param {number} [offset=0] - An optional offset value to add to the calculated height
 * @returns {null}
 */
export const setBottomContentHeight = (content, offset = 0) => {
  if (content) {
    const [playIcon, text] = [...content.childNodes];
    const visibleContentHeight = playIcon.offsetHeight + text.offsetHeight;
    content.style.height = `${visibleContentHeight + offset}px`;
  }
};

/**
 * Analitycs track for video stories on the reel
 * @param {number} position  -- index of the current video starting from 1
 * @param {number} totalCount -- total of videos in the same component
 * @returns {null}
 */
export const trackVideoStory = (
  position,
  totalCount = -1,
  category = "Reel without header"
) => {
  trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, {
    eventSubType: EVENT_TYPE.INTERACTION,
    component: {
      id: "video-play",
      type: "video",
      text: `Feature Reel: ${category}`,
      position: position + 1,
      totalCount: totalCount,
    },
  });
};
